// Display translation for COA (stored name_en / name_zh, AI-filled for custom accounts) & tax names / codes.
export function dcoa(code, name, lang, item) {
  if (item && lang === "en" && item.name_en) return item.name_en;
  if (item && lang === "zh" && item.name_zh) return item.name_zh;
  return name;
}

export const coaName = (c, lang) => dcoa(c?.code, c?.name, lang, c);

export function dtax(code, name, lang, item) {
  return (item && lang && lang !== "id" && item[`name_${lang}`]) || name;
}

export function dtaxCode(item, lang) {
  return (item && lang && lang !== "id" && item[`code_${lang}`]) || item?.code || "";
}

export const taxLabel = (x, lang) => `${dtaxCode(x, lang)} · ${dtax(x.code, x.name, lang, x)} (${x.rate}%)`;

export const isPpn = (x) => (x.group ? x.group === "PPN" : `${x.name}${x.code}`.toUpperCase().includes("PPN"));
export const isPph = (x) => (x.group ? x.group.startsWith("PPH") : `${x.name}${x.code}`.toUpperCase().includes("PPH"));
